@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

@if (!isLoader) {
  <div class="purchased-tracks__container">
    @for (track of tracks; track track) {
      <bmcore-purchased-track [track]="track"></bmcore-purchased-track>
    }
    @if (showNotPurchasedTracksMessage) {
      <bmcore-beats-not-found [title]="' No beats were found!'"> </bmcore-beats-not-found>
    }
  </div>
}
